
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fortnite",
      function () {
        return require("private-next-pages/fortnite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fortnite"])
      });
    }
  